import { render, staticRenderFns } from "./CardColorRatio.vue?vue&type=template&id=76527d1e"
import script from "./CardColorRatio.vue?vue&type=script&lang=js"
export * from "./CardColorRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports